(function() {
  const originalFetch = window.fetch;
  const redirectOpenKey = "mudify:open-cart-drawer";

  function hasAddonOnlyHeader(config = {}) {
    const headers = config.headers;
    if (!headers) return false;

    if (typeof Headers !== "undefined" && headers instanceof Headers) {
      return headers.get("X-Mudify-Addon-Only") === "1";
    }

    if (Array.isArray(headers)) {
      return headers.some(
        ([key, value]) =>
          String(key).toLowerCase() === "x-mudify-addon-only" &&
          String(value) === "1"
      );
    }

    if (typeof headers === "object") {
      for (const key of Object.keys(headers)) {
        if (
          key.toLowerCase() === "x-mudify-addon-only" &&
          String(headers[key]) === "1"
        ) {
          return true;
        }
      }
    }

    return false;
  }

  function hasDeferredCartRenderHeader(config = {}) {
    const headers = config.headers;
    if (!headers) return false;

    if (typeof Headers !== "undefined" && headers instanceof Headers) {
      return headers.get("X-Mudify-Deferred-Cart-Render") === "1";
    }

    if (Array.isArray(headers)) {
      return headers.some(
        ([key, value]) =>
          String(key).toLowerCase() === "x-mudify-deferred-cart-render" &&
          String(value) === "1"
      );
    }

    if (typeof headers === "object") {
      return Object.keys(headers).some(
        (key) =>
          key.toLowerCase() === "x-mudify-deferred-cart-render" &&
          String(headers[key]) === "1"
      );
    }

    return false;
  }

  function isPackageProtectionAdd(config = {}) {
    const body = config.body;

    if (typeof body !== "string") return false;

    try {
      const parsed = JSON.parse(body);
      return !!(
        parsed &&
        parsed.properties &&
        parsed.properties._package_protection
      );
    } catch (e) {
      return false;
    }
  }

  function requestIncludesSections(config = {}) {
    const body = config.body;
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      return body.has("sections");
    }
    if (typeof body !== "string") return false;
    try {
      const parsed = JSON.parse(body);
      return Array.isArray(parsed && parsed.sections) && parsed.sections.length > 0;
    } catch (e) {
      return false;
    }
  }

  function consumeRedirectOpenFlag() {
    try {
      const shouldOpen =
        window.sessionStorage.getItem(redirectOpenKey) === "1";
      if (shouldOpen) {
        window.sessionStorage.removeItem(redirectOpenKey);
      }
      return shouldOpen;
    } catch (e) {
      return false;
    }
  }

  function openCartDrawerAfterRedirect() {
    if (!consumeRedirectOpenFlag()) return;

    const openDrawer = () => {
      try {
        const drawer = document.querySelector("cart-drawer");
        if (!drawer) return;

        if (typeof drawer.refreshCartDrawer === "function") {
          drawer.refreshCartDrawer({ open: true }).catch((e) => {
            console.warn("Cart drawer open after redirect error:", e);
          });
          return;
        }

        if (typeof drawer.open === "function") {
          drawer.open();
        }
      } catch (e) {
        console.warn("Cart drawer open after redirect error:", e);
      }
    };

    if (
      window.customElements &&
      typeof window.customElements.whenDefined === "function"
    ) {
      window.customElements.whenDefined("cart-drawer").then(openDrawer);
      return;
    }

    openDrawer();
  }

  window.fetch = async function(resource, config = {}) {
    const isAdd =
      typeof resource === "string" && resource.includes("/cart/add.js");
    const isAddonOnly = isAdd && hasAddonOnlyHeader(config);
    const isProtectionAdd = isAdd && isPackageProtectionAdd(config);
    const isDeferredCartRender =
      isAdd && hasDeferredCartRenderHeader(config);

    const response = await originalFetch(resource, config);

    const hasSections = isAdd && requestIncludesSections(config);

    if (isAdd && response.ok) {
      if (window.PackageProtection?.clearCartCache) {
        window.PackageProtection.clearCartCache();
      }

      if (!isProtectionAdd && !isDeferredCartRender) {
        window.dispatchEvent(new CustomEvent("cart:updated"));
      }

      // Protection sync callers perform one final drawer refresh after the
      // correct tier is selected. Avoid an intermediate refresh containing a
      // stale protection price.
      if (!hasSections && !isProtectionAdd && !isDeferredCartRender) {
        try {
          const drawer = document.querySelector("cart-drawer");
          if (drawer && typeof drawer.refreshCartDrawer === "function") {
            const refreshOptions =
              isAddonOnly
                ? { preserveOpenState: true }
                : { open: true };

            drawer.refreshCartDrawer(refreshOptions).catch((e) => {
              console.warn("Cart drawer refresh error:", e);
            });
          }
        } catch (e) {
          console.warn("Cart drawer refresh error:", e);
        }
      }
    }

    return response;
  };

  openCartDrawerAfterRedirect();
})();
